export default function Chip(theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          fontWeight: 500,
          height: 32,
          '& .MuiChip-label': {
            paddingLeft: theme.spacing(2.5),
            paddingRight: theme.spacing(2.5),
            fontWeight: 500,
          },
        },
        sizeSmall: {
          height: 24,
          fontSize: '0.625rem',
          '& .MuiChip-label': {
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1.5),
            fontWeight: 500,
          },
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
        colorSecondary: {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
        },
        outlined: {
          borderWidth: 1.5,
        },
        deletable: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}

